<template>
    <section class="site">
        <article class="content-area">
            <slot name="navheader">
            </slot>

            <main>
                <slot name="content">
                </slot>
            </main>

             <site-footer v-if="hasFooter"></site-footer>
        </article>
        <site-aside></site-aside>
    </section>
</template>

<script>
  import SiteFooter from '@/components/SiteFooter.vue';
  import SiteAside from '@/components/SiteAside.vue';
 
  export default {
    name: "PageWithAside",
    props: {
        hasFooter: {type: Boolean, default: true}
    },
    components: {
        SiteFooter,
        "site-aside": SiteAside,
    }
  }
</script>